import React from 'react';
import { Box, Button } from '@mui/material';

interface IHistoryPaginationProps {
  currentPage: number;
  onChange: (page: number) => void;
  totalPages: number;
}

const HistoryPagination: React.FC<IHistoryPaginationProps> = ({
  currentPage,
  onChange,
  totalPages,
}) => {
  const safeTotalPages = Math.max(1, totalPages);

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        height: 58,
        justifyContent: 'center',
        pt: 1,
        visibility: safeTotalPages > 1 ? 'visible' : 'hidden',
      }}
    >
      {Array.from({ length: safeTotalPages }, (_, index) => {
        const page = index + 1;
        const isActive = page === currentPage;

        return (
          <Button
            key={page}
            onClick={() => onChange(page)}
            variant={'outlined'}
            sx={{
              // Active page: solid primary fill + white text. Inactive:
              // bordered transparent.
              backgroundColor: isActive ? 'primary.main' : 'transparent',
              borderColor: isActive ? 'primary.main' : 'divider',
              borderWidth: 1,
              boxSizing: 'border-box',
              color: isActive ? 'common.white' : 'text.primary',
              fontSize: 18,
              fontWeight: isActive ? 700 : 500,
              height: 42,
              minHeight: 42,
              minWidth: 42,
              p: 0,
              '&:hover': {
                backgroundColor: isActive ? 'primary.main' : 'transparent',
                borderColor: 'primary.main',
                color: isActive ? 'common.white' : 'text.primary',
              },
            }}
          >
            {page}
          </Button>
        );
      })}
    </Box>
  );
};

export default HistoryPagination;
